export function runOutsideAngularZone<T>(work: () => T): T {
  return typeof Zone === "undefined" ? work() : Zone.root.run(work);
}
